export default __webpack_public_path__ + "static/media/info.54d4c0ba.svg";